/**
 * @license @tabler/icons-react v3.42.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M10 13a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.45 11.55l2.05 -2.05", "key": "svg-1" }], ["path", { "d": "M6.4 20a9 9 0 1 1 11.2 0l-11.2 0", "key": "svg-2" }]];
const IconDashboard = createReactComponent("outline", "dashboard", "Dashboard", __iconNode);

export { __iconNode, IconDashboard as default };
//# sourceMappingURL=IconDashboard.mjs.map
